/** Keep in sync with the document editor mobile layout breakpoint. */
export const DOCUMENT_EDITOR_MOBILE_MAX_PX = 650;
